var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BaseModalForm', {
    attrs: {
      "headline": _vm.headline,
      "modalType": _vm.modalType
    },
    on: {
      "submit": _vm.handleSubmit,
      "close": function close($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('v-form', {
    ref: "connectForm",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Studiestedsnummer",
      "rules": [].concat(_vm.validateNotEmpty, [_vm.validateStudyLocationCode]),
      "counter": 3,
      "readonly": _vm.isEditModal,
      "required": "",
      "data-cy": "studyLocationCode"
    },
    model: {
      value: _vm.studyLocation.code,
      callback: function callback($$v) {
        _vm.$set(_vm.studyLocation, "code", $$v);
      },
      expression: "studyLocation.code"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Studiestedsnavn",
      "rules": [].concat(_vm.validateNotEmpty, [_vm.validateMaxLength(50, 'Studiestedsnavn')]),
      "counter": 50,
      "required": "",
      "data-cy": "studyLocationName"
    },
    model: {
      value: _vm.studyLocation.name,
      callback: function callback($$v) {
        _vm.$set(_vm.studyLocation, "name", $$v);
      },
      expression: "studyLocation.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.studyLocation.isActive ? 'Aktiv' : 'Inaktiv',
      "color": "primary",
      "inset": "",
      "hide-details": "",
      "data-cy": "studyLocationIsActive"
    },
    model: {
      value: _vm.studyLocation.isActive,
      callback: function callback($$v) {
        _vm.$set(_vm.studyLocation, "isActive", $$v);
      },
      expression: "studyLocation.isActive"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }